import React from "react";
import "../css/InputField.css";
import CuSpinner from "./CuSpinner";
import { Icon } from "semantic-ui-react";
import { SEARCH_ICON } from "../../cufront-assets/icons/Icons";
const InputField = ({
  placeholder,
  label,
  type,
  value,
  onChange,
  required,
  disabled,
  search = false,
  loading = false,
  isEdit = false,
  id,
  onKeyDown,
  onBlur,
  max,
  min = 0,
  step,
  setIsEdit = () => {},
}) => {
  return (
    <div className="custom-input-field" id="custom-input-field">
      <label className="custom-input-field-label lg:text-sm xl:text-base xlarge:text-xl">
        {label}
      </label>
      <input
        placeholder={placeholder}
        type={type}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
        id={id}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        max={max}
        // className="placeholder-color"
        min={min}
        step={step}
        className="lg:text-sm xl:text-base xlarge:text-xl"
      />
      {(loading || isEdit || search) && (
        <div
          className="cu-input-icon-container"
          style={{ top: search ? "calc(50% - 12px)" : "calc(50% - 0px)" }}
        >
          {loading && <CuSpinner />}
          {isEdit && <Icon name="lock" link onClick={() => setIsEdit(false)} />}
          {search && !loading && (
            <img
              src={SEARCH_ICON}
              style={{ width: "24px", height: "24px" }}
              alt="search icon"
            />
          )}
        </div>
      )}
    </div>
  );
};

export default InputField;
